import { render, staticRenderFns } from "./ApprovalForecast.vue?vue&type=template&id=c32795a2&scoped=true"
import script from "./ApprovalForecast.vue?vue&type=script&lang=js"
export * from "./ApprovalForecast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32795a2",
  null
  
)

export default component.exports